import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Online from './pages/Online';
import Offline from './pages/Offline';
import About from './pages/About';
import Privacy from './pages/Privacy';
import ReleaseNotes from './pages/ReleaseNotes';
import { useAuth } from './contexts/AuthContext';
import LoadingOverlay from './components/LoadingOverlay';

// Routes that fill the viewport and manage their own scrolling.
const WORKSPACE_ROUTES = ['/online', '/offline'];

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const mainContent = document.querySelector('[data-main-content]');
    if (mainContent) {
      mainContent.scrollTop = 0;
    }
  }, [pathname]);

  return null;
}

function App() {
  const { loading } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();

  const isWorkspace = WORKSPACE_ROUTES.includes(pathname);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <ScrollToTop />
      {loading && <LoadingOverlay />}

      <Sidebar
        isMobile={isMobile}
        mobileOpen={mobileOpen}
        onClose={() => setMobileOpen(false)}
      />

      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, minHeight: 0 }}>
        <Header isMobile={isMobile} onMenuClick={handleDrawerToggle} />

        <Box
          data-main-content
          sx={{
            flex: 1,
            minHeight: 0,
            // Workspace pages own their layout; content pages scroll normally.
            overflow: isWorkspace ? 'hidden' : 'auto',
            display: isWorkspace ? 'flex' : 'block',
            flexDirection: 'column'
          }}
        >
          <Routes>
            <Route path="/" element={<About />} />
            <Route path="/online" element={<Online />} />
            <Route path="/offline" element={<Offline />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/releases" element={<ReleaseNotes />} />
          </Routes>
        </Box>
      </Box>
    </Box>
  );
}

export default App;
